import { FormErrors } from '@moda/portal-stanchions';
import { useCallback } from 'react';
import { tc } from '../../lib/trackingContext';

export const useFormValidationTracking = () => {
  const trackFormValidation = useCallback((formName: string, errors: FormErrors) => {
    tc.track('Interacted with Form', {
      addToTrackingEvent: {
        formName,
        failedValidations: Object.keys(errors),
        errorMessages: Object.values(errors).map(err => err.message),
        label: formName
      }
    });
  }, []);

  return { trackFormValidation };
};
